import { DateTime } from 'luxon'

export const formattedTs = (ts: string) => {
  return DateTime.fromISO(ts).toFormat('EEE, MMM dd, HH:mm', { locale: 'it' })
}

export const formatISODate = (date: string, fmt = 'EEE, MMM dd, HH:mm') => {
  return DateTime.fromISO(date).toFormat(fmt, { locale: 'it' })
}
